import { isEmptyValue } from '../managerUtils';
import {
  JSONObject,
  JSONValue,
  LayoutInlineForm,
  LayoutObject,
} from '../../types/types';

// Matrix dialog defaults taken from the last selected object (the template):
// every matrixForm input whose name matches a property the template carries
// gets its value — e.g. the key width/height. Wins over the matrixDefault
// response; the user can still overwrite it in the dialog.
export const getMatrixTemplateDefaults = (
  template: LayoutObject | null,
  matrixForm: LayoutInlineForm | undefined
): JSONObject => {
  if (!template || !matrixForm) {
    return {};
  }

  const defaults: JSONObject = {};

  matrixForm.items.forEach((item) => {
    if (!item.name) {
      return;
    }

    const templateValue = template[item.name as keyof LayoutObject];

    if (!isEmptyValue(templateValue)) {
      defaults[item.name] = templateValue as JSONValue;
    }
  });

  return defaults;
};
